import { useEffect, useState } from "react";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import LanguagePills from "@/components/LanguagePills";
import { Input } from "@/components/ui/input";
import { MovieCard, EventCard } from "@/components/Cards";
import { Search as SearchIcon } from "lucide-react";
import { useApp } from "@/contexts/AppContext";

export default function Search() {
  const { categories } = useApp();
  const [q, setQ] = useState("");
  const [language, setLanguage] = useState("All");
  const [results, setResults] = useState({ movies: [], events: [], eventbrite: [] });

  useEffect(() => {
    const t = setTimeout(() => {
      const params = new URLSearchParams({ q });
      if (language !== "All") params.set("language", language);
      api.get(`/search?${params.toString()}`).then((r) => setResults(r.data));
    }, 200);
    return () => clearTimeout(t);
  }, [q, language]);
  const moviesEnabled = (categories || []).some((item) => item.name === "Movies");

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="page-shell py-10">
        <div className="relative">
          <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
          <Input
            data-testid="search-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search movies, events, venues…"
            className="pl-12 h-14 rounded-full text-lg"
            autoFocus
          />
        </div>
        <div className="mt-4">
          <LanguagePills value={language} onChange={setLanguage} />
        </div>

        <div className="mt-10 space-y-10">
          {moviesEnabled && results.movies.length > 0 && (
            <section>
              <h2 className="font-display text-xl font-extrabold mb-3">Movies</h2>
              <div className="flex gap-5 overflow-x-auto no-scrollbar">
                {results.movies.map((m) => <MovieCard key={m.movie_id} movie={m} />)}
              </div>
            </section>
          )}
          {results.events.length > 0 && (
            <section>
              <h2 className="font-display text-xl font-extrabold mb-3">Events</h2>
              <div className="flex gap-5 overflow-x-auto no-scrollbar">
                {results.events.map((e) => <EventCard key={e.event_id} event={e} />)}
              </div>
            </section>
          )}
          {results.eventbrite.length > 0 && (
            <section>
              <h2 className="font-display text-xl font-extrabold mb-3">Live on Eventbrite</h2>
              <div className="flex gap-5 overflow-x-auto no-scrollbar">
                {results.eventbrite.map((e) => <EventCard key={e.eventbrite_id} event={e} isLive />)}
              </div>
            </section>
          )}
          {!(moviesEnabled && results.movies.length) && !results.events.length && !results.eventbrite.length && (
            <p className="text-sm text-muted-foreground">Try searching for "Sonu", "Garba", "Kapil"…</p>
          )}
        </div>
      </main>
    </div>
  );
}
